import { createSlice } from '@reduxjs/toolkit';
import { updateData } from './reducers/update-data';

// RTK Query update: RTK slices can be used to update state in the Redux store (https://redux-toolkit.js.org/api/createSlice)
const teamstats = createSlice({
    name: 'update-data',
    initialState: {},
    reducers: {
        updateData
    }
});

// RTK Query update: Export the slice reducer and actions
if (PULSE.app.redux) {
    PULSE.app.redux.reducers.teamstats = {
        root: teamstats.reducer
    };
    PULSE.app.redux.actions = {
        ...PULSE.app.redux.actions,
        teamstats: teamstats.actions
    };
} else {
    PULSE.app.redux = {
        actions: {
            teamstats: teamstats.actions
        },
        reducers: {
            root: {
                teamstats: teamstats.reducer
            }
        }
    };
}
